import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, MARKET_DOWN_PROTECTION} from "../MarginQuizQuestions";

export const MarketDownProtection = "tfMarketDownProtectionQuestion";

export function marketDownProtection() {
    return {
        templateUrl: "app/quiz/margin/questions/MarketDownProtection.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: MarketDownProtectionController
    };
}

export class MarketDownProtectionController extends MarginQuizQuestionController {
    public config = MARKET_DOWN_PROTECTION;
}
